// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"0ea224f7b30c429c8823","961":"30e9abb6e758e9a17d3b","2467":"1d33525790d0c641aecc","2648":"eb1d1a09a2bc906a6573","4848":"fa5445cd2cdcaed33611","6540":"3c50d5d558fd1f8eb7d7"}[chunkId] + ".js";
};